import Head from 'next/head'

import { Footer } from 'app/RuangGtkHomePageV2/components/Footer'
import { RuangHero } from 'app/RuangGtkHomePageV2/components/Hero'
import { Navbar } from 'app/RuangGtkHomePageV2/components/Navbar'
import { RuangGTK } from 'app/RuangGtkHomePageV2/components/RuangGTK'

export default function RuangGtkHomePageV2() {
  return (
    <>
      <Head>
        <title>Beranda - Ruang GTK</title>
      </Head>
      <div className="min-h-screen w-full flex-col bg-gray-5">
        <header>
          <Navbar />

          <RuangHero />
        </header>

        <main>
          <section className="bg-gray-5">
            <RuangGTK />
          </section>
        </main>
      </div>

      <Footer />
    </>
  )
}
